<template>
    <div class="container has-text-centered bng-narrow-container bng-login">
        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <p
                            class="title is-3"
                        >{{"components.pages.password-restore.title" | translate}}</p>
                        <p
                            v-if="!passwordSent"
                            class="subtitle is-5"
                        >{{"components.pages.password-restore.help" | translate}}</p>
                        <p v-else class="subtitle is-5">
                            {{"components.pages.password-restore.sent to" | translate}}
                            <span
                                class="has-text-weight-bold"
                            >{{restoreData}}</span>
                        </p>

                        <form @submit.prevent="restorePassword">
                            <div class="field">
                                <div class="control">
                                    <div class="field">
                                        <template v-if="!passwordSent">
                                            <masked-phone v-if="client && client.login.phoneMask"
                                                          v-model="restoreData"
                                                          :mask="client.login.phoneMask"
                                                          v-validate="{ required: true, length: (client.login.phoneMask.match(/\d/g) || []).length }"
                                                          data-vv-name="password restore.data"
                                                          data-vv-validate-on="input"
                                                          class="input is-large"
                                                          autofocus />
                                            <input v-else
                                                   v-model.trim="restoreData"
                                                   v-validate="'required'"
                                                   data-vv-name="password restore.data"
                                                   data-vv-validate-on="input"
                                                   class="input is-large"
                                                   type="text"
                                                   autofocus
                                                   maxlength="50" />
                                        </template>
                                    </div>
                                    <p
                                        v-if="errors.has('password restore.data')"
                                        class="help is-danger"
                                    >{{ errors.first('components.pages.password-restore.data') | translate }}</p>
                                </div>
                            </div>

                            <recaptcha
                                v-show="false"
                                ref="recaptcha"
                                :on-response="response => { recaptchaResponse = response; }"
                            />

                            <div class="field" v-if="!passwordSent">
                                <button
                                    class="button is-link is-large"
                                    :disabled="($refs.recaptcha && !$refs.recaptcha.verified)"
                                >
                                    <span
                                        v-if="!loading"
                                    >{{"components.pages.password-restore.send" | translate}}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import authenticationService from '../../../../../../_common/services/authentication.service';

import Recaptcha from '../../../common/recaptcha/recaptcha.vue';
import MaskedPhone from '../../../common/phone-number/phone-number-masked.vue';

export default {
    name: 'password-restore',
    $_veeValidate: { validator: 'new' },
    components: { Recaptcha, MaskedPhone },
    data() {
        return {
            loading: false,
            restoreData: '',
            recaptchaResponse: null,
            passwordSent: false
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        }
    },
    methods: {
        resetFields() {
            this.restoreData = '';
        },
        async restorePassword() {
            await this.$validator.validateAll();
            if (this.errors.any()) return;
            this.errors.clear();
            this.passwordSent = true;
            await authenticationService.restorePassword(this.restoreData, this.recaptchaResponse);
        }
    },
    beforeDestroy() {
        this.resetFields();
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/password-restore/password-restore.vue